'use client';

import * as React from 'react';
import type { ContentProps } from '@mui/internal-docs-infra/CodeHighlighter/types';
import { useCode } from '@mui/internal-docs-infra/useCode';
import { CodeActionsMenu } from '../../../code-highlighter/demos/CodeActionsMenu';
import {
  CodeBlockHeader,
  CodeBlockHeaderLabel,
} from '../../../code-highlighter/demos/CodeBlockHeader';
import { CodeSource } from '../../../code-highlighter/demos/CodeSource';
import styles from './CodeEditorContent.module.css';

export function CodeEditorContent(props: ContentProps<object>) {
  const code = useCode(props, {
    preClassName: styles.codeBlock,
  });

  const hasJsTransform = code.availableTransforms.includes('js');
  const isJsSelected = code.selectedTransform === 'js';
  const toggleJs = (enabled: boolean) => code.selectTransform(enabled ? 'js' : null);

  return (
    <div>
      {code.allFilesSlugs.map(({ slug }) => (
        <span key={slug} id={slug} className={styles.fileRefs} />
      ))}
      <div className={styles.container}>
        <CodeBlockHeader
          roundedTop
          menu={
            <CodeActionsMenu
              inline
              onCopy={code.copy}
              fileUrl={code.selectedFileUrl}
              fileName={code.selectedFileName}
              fileSlug={code.selectedFileSlug}
              onReset={code.reset}
              jsTransform={
                hasJsTransform ? { enabled: isJsSelected, onToggle: toggleJs } : undefined
              }
            />
          }
        >
          <CodeBlockHeaderLabel>{code.selectedFileName}</CodeBlockHeaderLabel>
        </CodeBlockHeader>
        <CodeSource className={styles.code}>{code.selectedFile}</CodeSource>
      </div>
    </div>
  );
  // @focus-end
}
